export class LoginModel {
  Username: string;
  Password: string;
  RedirectUri: string;
  IpAddress?: string;
}

export class ChangePasswordModel {
  Username: string;
  Password: string;
  NewPassword: string;
}

export class RequestResetPasswordModel {
  Username: string;
}

export class ResetPasswordModel {
  RequestIdentifier: string;
  RequestCode: string;
  NewPassword: string;
}


export class AccountDetail {
  userId: number;
  isAdmin: boolean = false;
  userName: string;

}
